import type { FallbackError } from "@core/domain/errors/fallback.error.ts";
import type { ValidationError } from "@core/domain/errors/validation.error.ts";
import { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import type { LanguageRepository } from "@core/domain/repositories/language.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class LanguageUpdateUseCase {
    constructor(
        @inject(coreTypes.repositories.LanguageRepository)
        private readonly languageRepository: LanguageRepository,
    ) {}

    execute(
        language: LanguageIsoCodeEnum,
    ): ResultAsync<true, ValidationError | FallbackError> {
        return this.languageRepository.update(language);
    }
}
